// import RecentReport from "../components/RecentReport";
// import Stats from "../components/Stats";
// import LineChart from "../components/LineChart";
// import BarChart from "../components/BarChart";
// import useStockCalls from "../service/useStockCalls";
import { useEffect } from "react";
// import { useSelector } from "react-redux";
// import { LoadingMsg, NotFound } from "../components/DataMessage";
// import { Helmet } from "react-helmet";

const Dashboard = () => {
  // const { getStocks, getPromise } = useStockCalls();
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);

  // const { loading, error } = useSelector((state) => state.stock);

  return (
    <>
    <h1>orders</h1>
     
     
     
     </>
  );
};

export default Dashboard;
